"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionConfigurationWorker = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
class ExtensionConfigurationWorker {
    constructor(extensionConfiguration, pathConfigValueName, sharedExistingDotnetPath, unsupportedMessage = 'The shared existing path configuration is not supported.') {
        this.extensionConfiguration = extensionConfiguration;
        this.pathConfigValueName = pathConfigValueName;
        this.sharedExistingDotnetPath = sharedExistingDotnetPath;
        this.unsupportedMessage = unsupportedMessage;
    }
    getAllPathConfigurationValues() {
        return {
            individualizedExtensionPaths: this.pathConfigValueName ? this.extensionConfiguration.get(this.pathConfigValueName) : undefined,
            sharedExistingPath: this.sharedExistingDotnetPath ? this.extensionConfiguration.get(this.sharedExistingDotnetPath) : undefined
        };
    }
    getSharedPathConfigurationValue() {
        if (!this.sharedExistingDotnetPath) {
            throw new EventStreamEvents_1.EventBasedError('unsupportedSharedPathConfiguration', this.unsupportedMessage);
        }
        return this.pathConfigValueName ? this.extensionConfiguration.get(this.sharedExistingDotnetPath) : undefined;
    }
    setSharedPathConfigurationValue(configValue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.sharedExistingDotnetPath) {
                throw new EventStreamEvents_1.EventBasedError('unsupportedSharedExistingPathConfiguration', this.unsupportedMessage);
            }
            yield this.extensionConfiguration.update(this.sharedExistingDotnetPath, configValue, true);
        });
    }
}
exports.ExtensionConfigurationWorker = ExtensionConfigurationWorker;
//# sourceMappingURL=ExtensionConfigurationWorker.js.map